var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3126 0.446964C15.617 0.157109 16.0222 -0.00313416 16.4425 4.6458e-05C16.8629 0.00322708 17.2656 0.169583 17.5656 0.464012C17.8656 0.75844 18.0396 1.15791 18.0507 1.57813C18.0618 1.99836 17.9092 2.40646 17.6252 2.71633L9.00156 13.5012C8.85327 13.661 8.6743 13.7891 8.47535 13.8781C8.27639 13.9671 8.06154 14.015 7.84364 14.019C7.62574 14.0231 7.40926 13.9831 7.20715 13.9016C7.00504 13.82 6.82144 13.6986 6.66735 13.5445L0.948538 7.82565C0.789279 7.67725 0.661541 7.4983 0.572945 7.29946C0.484349 7.10062 0.43671 6.88597 0.432869 6.66833C0.429029 6.45068 0.469067 6.23448 0.550594 6.03264C0.63212 5.8308 0.753466 5.64745 0.907391 5.49353C1.06132 5.3396 1.24467 5.21825 1.44651 5.13673C1.64835 5.0552 1.86454 5.01516 2.08219 5.019C2.29984 5.02284 2.51449 5.07048 2.71333 5.15908C2.91216 5.24767 3.09112 5.37541 3.23952 5.53467L7.76529 10.0583L15.2715 0.494513C15.285 0.477873 15.2994 0.461998 15.3147 0.446964H15.3126Z",
    fill: "#43A047"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessMessageIcon);
export default __webpack_public_path__ + "static/media/success-message-icon.c55e30fdc5c237be2c80578695f1d78a.svg";
export { ForwardRef as ReactComponent };